import moment from 'moment-timezone';
import { HttpResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpEventType } from '@angular/common/http';
import { RequestCacheService } from '@zaoblako/web/core/services/request-cache.service';
import { Injectable } from '@angular/core';
import { map, mergeAll } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class CacheInterceptor implements HttpInterceptor {
  public constructor(
    private requestCacheService: RequestCacheService
  ) {}


  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.method.toUpperCase() !== 'GET') { // Only GET-requests will be cached
      return next.handle(req);
    }

    return this.requestCacheService
      .getResponse(req.urlWithParams)
      .pipe(map((cached) => {
        if (cached?.lastModified) {
          if (environment.debugLog) {
            console.debug(`[CacheInterceptor] Resource "${req.urlWithParams}" was last modified at ${cached?.lastModified}`);
          }
          return req.clone({ headers: req.headers.set('If-Modified-Since', cached?.lastModified) });
        } else {
          return req;
        }
      }))
      .pipe(map((req) => next.handle(req)))
      .pipe(mergeAll())
      .pipe(map((res: HttpResponse<any>) => {
        if (res.type !== HttpEventType.Response) {
          return res;
        }

        // Response to cache must have:
        //  - Body;
        //  - "Last-Modified" header;
        //  - Succeed status code (from 200 to 299)
        if (res.body && res.headers.has('Last-Modified') && res.status >= 200 && res.status < 300) {
          this.requestCacheService
            .setResponse(req.urlWithParams, {
              created: moment().startOf('second').toDate(),
              lastModified: res.headers.get('Last-Modified'),
              status: res.status,
              statusText: res.statusText,
              body: res.body
            })
            .subscribe(() => {
              if (environment.debugLog) {
                console.debug(`[CacheInterceptor] Resource "${req.urlWithParams}" cached`);
              }
            });
        }
        return res;
      }))
  }
}
